// const SESSION_DURATION_MS = 30 * 1000; // 30 seconds
const SESSION_DURATION_MS = 12 * 60 * 60 * 1000; // 12 hours
const EXPIRY_KEY = "sessionExpiry";

let _timerId = null;

function _clearTimer() {
  if (_timerId !== null) {
    clearTimeout(_timerId);
    _timerId = null;
  }
}

function _expire() {
  _timerId = null;
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/login";
}

export function resetSessionTimer() {
  if (!localStorage.getItem("token")) return;
  _clearTimer();
  const expiry = Date.now() + SESSION_DURATION_MS;
  localStorage.setItem(EXPIRY_KEY, expiry.toString());
  _timerId = setTimeout(_expire, SESSION_DURATION_MS);
}

export function startSessionTimer() {
  if (!localStorage.getItem("token")) return;
  _clearTimer();

  const stored = localStorage.getItem(EXPIRY_KEY);
  if (stored) {
    const remaining = parseInt(stored, 10) - Date.now();
    if (remaining > 0) {
      _timerId = setTimeout(_expire, remaining);
      return;
    }
    // Session expired while the page was closed — log out immediately.
    _expire();
    return;
  }

  // No prior expiry stored — fresh session start.
  resetSessionTimer();
}

export function stopSessionTimer() {
  _clearTimer();
  localStorage.removeItem(EXPIRY_KEY);
}
